import { render, staticRenderFns } from "./ApplicantMessageHistory.vue?vue&type=template&id=5b836cc0"
import script from "./ApplicantMessageHistory.vue?vue&type=script&lang=js"
export * from "./ApplicantMessageHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports